
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/obchodni-podminky-pro-cc",
      function () {
        return require("private-next-pages/obchodni-podminky-pro-cc.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/obchodni-podminky-pro-cc"])
      });
    }
  